import svgToDataUri from 'mini-svg-data-uri';
export function svgToCss(svg) {
    return `url("${svgToDataUri(svg)}")`;
}

//# sourceMappingURL=svg.js.map